<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 13 }"
    >

          <a-form-item label="模型标识">
            <a-input v-decorator="['key',rules.key]"/>
          </a-form-item>
          <a-form-item label="模型名称">
            <a-input v-decorator="['name',rules.name]"/>
          </a-form-item>
          <a-form-item label="描述">
            <a-input v-decorator="['desc']"/>
          </a-form-item>

    </a-form>


    <a-space class="a-form-btn-box">
      <a-button type="primary" @click="_save()">提交</a-button>
      <a-button @click="endEdit('cancelled')">取消</a-button>
    </a-space>


  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
import {CONSTANT as constant} from '@/services/constant';
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.info(constant, fmt, loadBaseCodeData);//避免报错
//厂商用户管理接口
import {dataApi} from '@/services/workflow/modelManage';


/**
 * 加载规则 必填控制
 */
function getRulesTemplate() {
  return {
    key: {
      rules: [{required: true, whitespace: true, message: "请输入模型标识"}]
    },
    name: {
      rules: [{required: true, whitespace: true, message: "请输入模型名称"}]
    },
  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {};
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */


async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  //给主键赋值
  entities.id = vm.keyId;
  return await dataApi.saveFormDetail(entities);
}

/**
 * 加载基础数据
 */
async function loadBaseData() {

}

/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {},
  data() {
    return {
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
  }
};
</script>

<style scoped lang="stylus">

</style>